export default {
  AsterContact: {
    getdata: [],
  },
};
